module.exports = __webpack_public_path__ + "img/chatbots_constructor.ffaca69d.png";